import * as fileService from '../HttpService/FileManager';
import * as PropertyBucket from "../../Properties/Properties";
import * as httpService from "../HttpService/HttpService";


export const downloadBlobUrl = (fileId) => {
  return fileService.getDocumentFile(fileId)
      .then(response => response.blob())
      .then(blob => window.URL.createObjectURL(new Blob([blob])))
};

export const downloadFile = (parentContainerRef, fileId, fileName) => {
  return fileService.getDocumentFile(fileId)
  .then((response) => response.blob())
  .then((blob) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const $link = document.createElement('a');
    $link.href = url;
    $link.setAttribute('download', fileName);

    // add to parent component, trigger click and remove
    parentContainerRef.appendChild($link);
    $link.click();
    parentContainerRef.removeChild($link);
    window.URL.revokeObjectURL(url);
  })
};

export const downloadXLSXFile = (fileName, controlStatus, sortBy, sortOrder) => {
  return fileService.getControlListXLSXFile(controlStatus, sortBy, sortOrder)
  .then((response) => response.blob())
  .then((blob) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const $link = document.createElement('a');
    $link.href = url;
    $link.setAttribute('download', fileName);

    document.body.appendChild($link);
    $link.click();
    document.body.removeChild($link);
    window.URL.revokeObjectURL(url);
  })
};

export const serializeInitialAttachmentsForForm = (attachments) => {
  return attachments.map(attachment => {
    attachment.toRemove = false;
    return attachment
  }).sort((firstEl, secondEl) => new Date(firstEl?.audit?.createdOn) - new Date(secondEl?.audit?.createdOn))
};

export const serializeFromDocumentToAttachment = (document) => ({
  document,
  toRemove: false
});

/** This is fixed version for INF, in case of issues in other areas it can be applied. */
export const serializeAttachmentsForPostControlInfoSaving = (attachments, withOrderNumber = false) => {

  const rawAttachments = attachments.map(attachment => ({
	  documentId: attachment.document.id,
    id: attachment.id,
    toRemove: attachment.toRemove || false,
    ...(withOrderNumber ? {orderIndex: attachment.orderIndex} : {})
  }));

  return rawAttachments;
};

export const serializeAttachmentsForSaving = (attachments, withOrderNumber = false) => {
  return attachments.map(attachment => ({
	  document: {id: attachment.document.id},
	  documentId: attachment.document.documentId,
    id: attachment.id,
    toRemove: attachment.toRemove || false,
    ...(withOrderNumber ? {orderIndex: attachment.orderIndex} : {})
  })).filter(attachment => !attachment.toRemove || !!attachment.id)
};

export const getAttachmentsOnList = (allAttachments) =>
  allAttachments.filter(attachment => !attachment.toRemove)
      .sort((firstEl, secondEl) => new Date(firstEl?.audit?.createdOn) - new Date(secondEl?.audit?.createdOn));

export const getExcludedDocumentsIdsForJoining = (attachments) =>
    attachments.map(attachment => attachment.id);

export const addAttachmentsToPrevList = (attachments, newAttachments) => {
  if (!attachments.length) { return newAttachments }

  const newAttachmentList = [...attachments];
  let existingIds = newAttachmentList.map(attachment => attachment.document.id);
  for (let newAttachment of newAttachments) {
    const documentId = newAttachment.document.id;

    // check if such a document is already attached
    if (existingIds.includes(documentId)) {
      for (let attachment of newAttachmentList) {
        if (attachment.document.id === documentId) {
          attachment.toRemove = false;
          break
        }
      }
    } else {
      existingIds.push(documentId);
      newAttachmentList.push(newAttachment);
    }
  }
  return newAttachmentList
};

export const setAttachmentAsRemoved = (attachments, documentId, withOrderNumber = false) => {
  return attachments.map(attachment => {
    if (attachment.document.id === documentId) {
      attachment.toRemove = true;
      if (withOrderNumber) {
        attachment.orderIndex = null;
      }
    }
    return attachment
  })
};

export const setAllAttachmentsAsRemoved = (attachments) => {
  return attachments.map(attachment => {
    attachment.toRemove = true;
    return attachment
  })
};

export const setAttachmentsOrderNumbers = (attachments) => {
  let index = 1;
  return attachments.map(attachment => {
    attachment.orderIndex = attachment.toRemove ? null : index++;
    return attachment
  });
};

export const sortAttachmentsByOrderIndex = (attachment1, attachment2) => {
  return attachment1.orderIndex - attachment2.orderIndex
};

export const getFileNameListForPdf = (attachments) => {
  return attachments
      .map(attachment => attachment?.file?.fileName || null)
      .filter(fileName => fileName !== null)
};

export const getFileNameListForPdfWithDocument = (attachments) => {
  return attachments
      .map(attachment => attachment?.document?.file?.fileName || null)
      .filter(fileName => fileName !== null)
};

export const getTextWithLines = (text) => {
  return `––– ${text} ${new Array(75 - text.length).join('–')}`
};

export const endsControlWithAfterControlNote = (documents) => {
	return (documents || [])
		.filter(doc => doc.postControlNote !== null).length > 0

};

export const getPostControlDocuments =  (controlId) => {
	return new Promise((resolve, reject) => {
		let url = PropertyBucket.getPostControlDocumentByControlId(controlId);
		let controlResponse = httpService.getService(url, 'GET');
		return controlResponse.then(
				data => {
					resolve(data)
				})
			.catch(error => {console.log(error)})
	})
}

export const mapNewAttachments = (documents, data) => {
	return documents.attachments.map(el => {
		const attachmentObject = data.documents.find(el2 => {
			return el2.attachments.find(el3 => el3.id === el.id)
		})
		return {
			id: attachmentObject.attachments[0].id,
			orderIndex: attachmentObject.attachments[0].orderIndex,
			uuid: attachmentObject.attachments[0].uuid,
			document: {
				id: attachmentObject.id,
				file: attachmentObject.file
			}
		}
	})
}

/** This is fixed version for INF, in case of issues in other areas it can be applied. */
export const mapNewAttachmentsForPostControlInfo = (documents, data) => {
	return documents.attachments.map(el => {
		const attachmentObject = data.documents.find(el2 => {
			return el2.attachments.find(el3 => el3.id === el.id)
		})
		return {
			id: el.id,
			orderIndex: el.orderIndex,
			uuid: el.uuid,
			document: {
				id: attachmentObject.id,
				file: attachmentObject.file
			}
		}
	})
}

export const mapNewFindings = (document, data) => {
	if (document.findings) {
		document.findings.map(el => {
 			el.blockInList =data.questionList.blocksInList.find(el2 => el2.id === el.blockInList.referenceId)
		})
	}

}

export const mapControlBlockOccurance = (control) => {
    let map = new Map();
    control.questionList.blocksInList
        .forEach(bc => {
            if (!map.has(bc.id)) {
                map.set(bc.id, bc);
            }
        });
    return map
}

export const mapPaymentClaims = (data, findingsData) => {
	if (findingsData && findingsData.length > 0) {
		findingsData.forEach(el => {
			if (el.corrections && el.corrections.length > 0) {
				el.corrections.forEach(el2 => {
          if(el2.paymentClaim) {
            el2.paymentClaim = data.paymentClaims.find(el3 => el3.id === el2.paymentClaim.referenceId)
          }
				})
			}
		})
	}
}
export const mapOrders = (data, findingsData) => {
	if (findingsData && findingsData.length > 0) {
		findingsData.forEach(el => {
			if (el.corrections && el.corrections.length > 0) {
				el.corrections.forEach(el2 => {
					el2.order = data.orders.find(el3 => el3.id === el2.order?.referenceId)
				})
			}
		})
	}
}
export const mapNewAnswersToQuestion = (control) => {
	let answersByQuestionMap = new Map(control.answers
		.map(el => {
			el.attachments?.forEach(att => att.document = control.documents.find(it => it.id == att.document.referenceId));
			return el;
		})
		.map(el => [el.questionInBlock.referenceId, el]))
	control.questionList.blocksInList
		.flatMap(el => el.questionsInBlock)
		.forEach( question => {
      question.answers = answersByQuestionMap.get(question.id) || {};
    });
}

export const getDividedStringIntoSpans = (str, numSpacesInsteadTab = 4) => {
  return str?.split('\n')?.map(line => {
      const formatedLine = line.replaceAll('\t', '\xa0'.repeat(numSpacesInsteadTab)).replaceAll('/\s/g', '\xa0');
      return <span><span> </span>{formatedLine}{'\n'}</span>
  });
}